import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function ChevronUpIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="m18 15-6-6-6 6" />
    </StrokeIcon>
  );
}
